import React from 'react'
import styled from '@emotion/styled'
import { SkeletonPulse, radius, space } from '@ticketswap/solar'
import { generateSkeletons } from '~/utils'

const StyledSkeletonPulse = styled(SkeletonPulse)`
  display: block;
  border-radius: ${radius.lg};
  height: ${space[256]};
`

export function Skeleton({ count = 1 }) {
  return generateSkeletons(
    <div>
      <StyledSkeletonPulse />
    </div>,
    count
  )
}
